export default {"src":"/_next/static/media/icon-stats-defense.b9f0e601.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};